module.exports = __webpack_public_path__ + "img/swarm of servants.149cc2b8.png";